import React from 'react';
import { Button, CircularProgress, Box } from '@mui/material';

const ActionButton = ({
  children,
  loading = false,
  loadingText = 'Loading...',
  ...props
}) => {
  return (
    <Button
      {...props}
      disabled={loading || props.disabled}
      sx={{
        ...props.sx,
        '&:disabled': {
          backgroundColor: '#CCCCCC',
          color: '#666666'
        }
      }}
    >
      {loading ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <CircularProgress size={16} color="inherit" />
          {loadingText}
        </Box>
      ) : (
        children
      )}
    </Button>
  );
};

export default ActionButton;
